/**
 * Returns incoming `data.data` if argument is valid
 *
 * @param {Array} [data] Optional data array argument
 * @param {object | Array | string} [data.data] Data property, that will be returned if present
 * @returns {object | Array | string} Either an empty array or `data.data` if the argument is valid
 */
const pluckData = data => data && data.data || [];

/**
 * Extends all objects from data argument array with a name property
 *
 * @param {Array} data - Data argument. Can be either empty or filled with objects
 * @param {string} data[0].text - Text as a string, that will be used to generate new `name` prop
 * @returns {Array} Either empty array or array of objects with at least `text` and `name` props
 */
const mapTextToName = data => {
  return data.map(entry => {
    entry.name = entry.text;
    return entry;
  });
};

/**
 * In incoming data argument, for each object, swaps ID for placeKey prop, formats ID into numeric
 * ID. Note that the incoming IDs hae to follow the slug and ID format (`foo-123`)
 *
 * @param {Array} data - Data argument. Can be either empty or filled with objects
 * @param {string} data[0].id - ID passed as string that MUST follow pattern `foo-123` `slugand-id`
 * @returns {Array} Either empty array or array of objects with at least `id` and `placeKey` props
 */
const toNumericId = data => data.map(entry => {
  entry.placeKey = entry.id;
  entry.id = entry.id.split('-')[1];
  return entry;
});

/**
 * In incoming data argument, remove duplicated objects if `name` property is already taken
 *
 * @param {Array} data - Data argument. Can be either empty or filled with objects
 * @param {string} data[0].name - Name as a string
 * @returns {Array} Either empty array or array of objects without duplicates based on `name` prop
 */
const uniqByName = (data) => {
  return Object.values(data.reduce((acc, cur) => {
    const name = cur.name;
    if (!acc[name]) {
      acc[name] = cur;
    }
    return acc;
  }, {}));
};

export {
  pluckData,
  mapTextToName,
  toNumericId,
  uniqByName,
};
